import { render, staticRenderFns } from "./CheckoutDetailComponent.vue?vue&type=template&id=2b7c4ec5"
import script from "./CheckoutDetailComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckoutDetailComponent.vue
// module id = null
// module chunks = 